import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tc-kpi-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './kpi-card.component.html',
  styleUrl: './kpi-card.component.css',
})
export class KpiCardComponent {
  label = input.required<string>();
  value = input.required<number | string>();
  footer = input<string>('');
  variant = input<'blue' | 'green' | 'amber' | 'red' | 'gray'>('blue');
}
